const BLOCK_SIZE = 4 * 1024 * 1024;
const PARALLEL_BLOCKS = 4;

function generateBlockId(index) {
  return btoa(String(index).padStart(8, "0"));
}

async function uploadSingleBlock(uploadUrl, file, onProgress) {
  const res = await fetch(uploadUrl, {
    method: "PUT",
    headers: {
      "x-ms-blob-type": "BlockBlob",
      "x-ms-version": "2020-10-02",
      "Content-Type": "application/pdf",
    },
    body: file,
  });
  if (!res.ok) throw new Error(`Upload failed: ${res.status}`);
  onProgress && onProgress(100);
}

async function uploadChunked(uploadUrl, file, onProgress) {
  const blockCount = Math.ceil(file.size / BLOCK_SIZE);
  const blockIds = [];
  const urlObj = new URL(uploadUrl);
  const baseUrl = `${urlObj.origin}${urlObj.pathname}`;
  const sasQuery = urlObj.search;
  let uploadedBlocks = 0;

  async function uploadBlock(j) {
    const blockId = generateBlockId(j);
    const start = j * BLOCK_SIZE;
    const end = Math.min(start + BLOCK_SIZE, file.size);
    const chunk = file.slice(start, end);
    const blockUrl = `${baseUrl}${sasQuery}&comp=block&blockid=${encodeURIComponent(blockId)}`;
    const res = await fetch(blockUrl, {
      method: "PUT",
      headers: { "x-ms-version": "2020-10-02", "Content-Type": "application/octet-stream" },
      body: chunk,
    });
    if (!res.ok) throw new Error(`Block ${j} failed: ${res.status}`);
    uploadedBlocks++;
    onProgress && onProgress(Math.round((uploadedBlocks / blockCount) * 95));
    return blockId;
  }

  for (let i = 0; i < blockCount; i += PARALLEL_BLOCKS) {
    const batch = [];
    for (let j = i; j < Math.min(i + PARALLEL_BLOCKS, blockCount); j++) {
      batch.push(uploadBlock(j));
    }
    const ids = await Promise.all(batch);
    blockIds.push(...ids);
  }

  const blockListXml = `<?xml version="1.0" encoding="utf-8"?>\n<BlockList>\n${blockIds.map(id => `  <Latest>${id}</Latest>`).join("\n")}\n</BlockList>`;
  const commitRes = await fetch(`${baseUrl}${sasQuery}&comp=blocklist`, {
    method: "PUT",
    headers: {
      "x-ms-version": "2020-10-02",
      "Content-Type": "application/xml",
      "x-ms-blob-content-type": "application/pdf",
    },
    body: blockListXml,
  });
  if (!commitRes.ok) throw new Error(`Commit failed: ${commitRes.status}`);
  onProgress && onProgress(100);
}

export async function uploadToAzure(uploadUrl, file, onProgress) {
  if (file.size < 50 * 1024 * 1024) {
    return uploadSingleBlock(uploadUrl, file, onProgress);
  } else {
    return uploadChunked(uploadUrl, file, onProgress);
  }
}
